interface IProps {
    message: string
}

const UserMessage = ({message}: IProps) => {
    return (
        <div className="flex items-center justify-end m-[20px] mr-0">
            <div className="bg-user rounded-2xl rounded-br-none p-[20px] pt-[12px] pb-[12px]">{message}</div>
        </div>
    )
}

export default UserMessage
